import { formatDate } from "@angular/common";
import { Injectable } from "@angular/core";
import { Adapter } from "@core/adapter";
import { Place } from "../place.model";


  export interface SessionListItem{
    id:string,
    name:string,
    date?: Date,
    startTime: string,
    endTime: string,
    location?: Place,
    onDemand:boolean,
    availableUntil?: Date,
    availableUntilCalculated?: Date,
    inThePast:boolean
  }

  @Injectable({
    providedIn: 'root'
  })

  export class SessionListItemAdapter implements Adapter<SessionListItem> {
  adapt(s: any): SessionListItem {   

    const session = {
      id:s.id,
      name:s.name,
      date:s.date,
      startTime:s.startTime??'',
      endTime:s.endTime??'',
      location:s.location,
      onDemand:s.onDemand,
      availableUntil:s.availableUntil,
      availableUntilCalculated:s.availableUntilCalculated,
      inThePast: false
    } as SessionListItem;
    session.inThePast = this.inThePast(session);
    return session;
  }

  private inThePast(session:SessionListItem):boolean{
    let currentDate = new Date();
    currentDate.setHours(0,0,0,0);
    const currentTime = currentDate.getTime();
    
    if(session.onDemand){
        if(session.availableUntilCalculated){
          return new Date(session.availableUntilCalculated).getTime() < currentTime;
        }else if(session.availableUntil){
            return new Date(session.availableUntil).getTime() < currentTime;
        }else{
          return false;
        }
    }else{
      return new Date(session.date!).getTime() < currentTime;
    }
  } 
}


